export const LOGIN_API_ENDPOINT = "/api/login";
export const GENERATE_OTP_ENDPOINT =
  `${LOGIN_API_ENDPOINT}/onetimepasscode/send` as const;
export const LOGIN_WITH_OTP_ENDPOINT =
  `${LOGIN_API_ENDPOINT}/onetimepasscode` as const;

export const COUNTRIES_API_ENDPOINT = "/api/license/countries";
